<div class="row">
  <div class="col-md-12">
    <h4>Versand Fehler</h4>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    @if (data.data$ | async; as errors) {
      <table class="table whitetable">
        <thead>
          <tr>
            <th>Rechnungs Nr.</th>
            <th>Art</th>
            <th>Fehler</th>
            <th>Datum</th>
            @if ('post.cleanup'|HasPerm) {
              <th>&nbsp;</th>
            }
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          @for (job of errors; track job; let index = $index) {
            <tr>
              <td>{{ job.invoice_id }}</td>
              <td>{{ job.type }}</td>
              <td>@for (error of job.errors; track error) {
                {{ error.description }},
              }</td>
              <td>{{ job.date_created|date:'dd.MM.yyyy HH:mm' }}</td>
              @if ('post.cleanup'|HasPerm) {
                <td>
                  <button type="button" class="btn btn-sm btn-default" (click)="clean(errors, index, job)">
                    Auftrag löschen
                  </button>
                </td>
              }
              <td>
                <button type="button" class="btn btn-sm btn-success" (click)="restart(errors, index, job)">
                  Rechnung erneut versenden
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
    }

    <loading-or-error
      #loadingOrError
      [loadingWrapper]="data"
      [errorMessage]="'Konnte Versand Fehler nicht laden'">
    </loading-or-error>
  </div>
</div>
